import { Component, OnInit } from '@angular/core';
import { ModalService } from './modal.service';
import { Modal } from './modal';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-modal',
	templateUrl: './modal.component.html',
	styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
	isShowing: boolean;
	modal: Modal;
	saving: boolean;

	constructor(private modalService: ModalService) {}

	ngOnInit() {
		this.isShowing = false;
		this.modalService.modals.subscribe(modal => (this.modal = modal));
		this.modalService.isShowingFlags.subscribe(isShowing => {
			if (isShowing) this.saving = false;
			this.isShowing = isShowing;
		});
	}

	confirm() {
		this.saving = true;
		this.modalService.closeConfirm();
	}

	cancel() {
		this.modalService.closeCancel();
	}
}
